import { render, staticRenderFns } from "./ProductTypeManage.vue?vue&type=template&id=9d46a902&"
import script from "./ProductTypeManage.vue?vue&type=script&lang=js&"
export * from "./ProductTypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports